<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{ 'Announcement' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-item lines="none">
        <ion-textarea
            [(ngModel)]="message"
            [placeholder]="'Enter announcement message' | translate"
            [autoGrow]="true"
            rows="3"
        ></ion-textarea>
    </ion-item>

    <ion-item lines="none">
        <ion-label>{{ 'Enable Announcement' | translate }}</ion-label>
        <ion-toggle [(ngModel)]="enabled" slot="end"></ion-toggle>
    </ion-item>

    <ion-button 
        expand="block" 
        (click)="saveAnnouncement()" 
        [disabled]="isSaving"
        style="margin-top: 20px;"
    >
        @if (isSaving) {
            <ion-spinner name="crescent"></ion-spinner>
        } @else {
            {{ 'Save' | translate }}
        }
    </ion-button>
</ion-content>
